module.exports = __webpack_public_path__ + "static/media/Chernihiv_tv_gif.66da0107.gif";